<div class="product-listing-slider top-margin d-none" *ngIf="!noRecord">
  <div class="product-listing-slider-wrapper">
    <div class="info-part" *ngIf="!noRecord">
      <h3>
        <img *ngIf="salesRepDetail.salesrep_image" src="{{profileImagePath}}{{salesRepDetail.salesrep_image}}"
          alt="{{salesRepDetail.salesrep_image}}">
        <img *ngIf="!salesRepDetail.salesrep_image" src="../../../../assets/images/profile.svg"
          alt="{{salesRepDetail.salesrep_image}}">
        <span>{{salesRepDetail.sales_rep_name}}</span>
      </h3>
      <p>Hey, I have been reviewing your Range & Orders. I highly recommend you stock these great products.</p>
      <a href="javascript:void(0)" class="btn primary-btn view-btn-home"
        [routerLink]="['/product/suggested-products']">View All</a>
    </div>
    <div class="product-container scrollbar" *ngIf="!noRecord" infiniteScroll [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="false" [horizontal]="true">
      <div class="product-wrapper" id="product_{{product.sku}}" *ngFor="let product of productList">
        <div class="product-image">
          <a [routerLink]="['/product/detail',product.sku]">
            <img src="{{imagePath}}{{product?.images[0]}}" alt="" width="100%">
          </a>
        </div>
        <div class="product-description">
          <a routerLink="/product/detail/{{product.sku}}" class="product-detail-name-bar">
            <h2>{{product.short_desc}} </h2>
          </a>
          <ul class="order-quantity-details">
            <li *ngIf="global_data != null && global_data?.margin_visibility == 1">
              <span>Margin</span>
              <p><span>{{product.margin}}%</span></p>
            </li>
            <li *ngIf="global_data != null && global_data?.price_visibility == 1">
              <span>Cost</span>
              <p><strong>£{{product.price}}</strong></p>
            </li>
          </ul>
          <div class="btn-group">
            <button *ngIf="product.item_id == ''"
              [ngClass]="{'btn not-interested-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}"
              id="notinterestbtn_{{product.product_id}}" (click)="notInteretedSuggest(product)">Not Interested</button>
            <button [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}"
              id="btn_{{product.product_id}}"
              *ngIf="product.item_id == '' && miniCartDetails != null && miniCartDetails.items_count != 0"
              (click)="addToCart(product, product.qty, '', 'common', commonTemplate,commonTemplateFor24HrPopup,true)">Add</button>
            <button [ngClass]="{'btn primary-btn':true, 'disabled':product.back_in_stock == '0' ?true : false}"
              id="btn_{{product.product_id}}" *ngIf="product.item_id == '' && miniCartDetails.items_count == 0"
              (click)="addToCart(product, product.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,true)">Add</button>

            <p *ngIf="product.back_in_stock == '0'" class="product-cart-status d-md-flex"> <img
                src="../../assets/images/cross-round.svg" alt="checked icon" />Out of Stock
            </p>
          </div>
          <ngx-number-spinner id="spinerbtn_{{product.product_id}}" *ngIf="product.item_id != ''"
            [ngClass]="{'spinner':true, 'disabled':product.back_in_stock == '0' ?true : false}"
            [value]="toInteger(product.qty)" [min]="0" (change)="send(product, $event, commonTemplate)">
          </ngx-number-spinner>
        </div>
      </div>
    </div>

  </div>
</div>

<ng-template #addToCartTemplate>
  <div class="modal-header border-0 pb-2 align-items-center flex-column">
    <h4 class="modal-title">Info</h4>
    <p>You are about to create a order for</p>
    <h4 class="modal-title">{{selectedStore.selectedStoreName}}</h4>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p>Please change the store if you want to create an order for another store.</p>
        </div>
        <div class="button-success text-center mt-3">
          <button class="common-button mr-3" (click)="bsModalRef.hide()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #commonTemplate>
  <div class="modal-header border-0 pb-2 align-items-center">
    <h4 class="modal-title">Info</h4>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p>{{popupMessage}} </p>
        </div>
        <div class="button-div text-center mt-3 align-items-center">
          <button class="common-button mr-3" (click)="bsModalRef.hide()">{{commonBottonText}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #commonTemplateFor24HrPopup>
  <div class="modal-header border-0 pb-2 align-items-center">
    <h4 class="modal-title">Info</h4>
  </div>
  <div class="modal-body py-0 px-0">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center">
          <p style="white-space: pre-wrap">{{popupMessage}} </p>
        </div>
        <div class="button-div text-center mt-3 align-items-center">
          <button class="common-button mr-3" (click)="bsModalRef.hide()">Cancel</button>
          <button class="common-button mr-3"
            (click)="addToCart(product_for_24_hr, product_for_24_hr.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,false)">{{commonBottonText}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>



<div class="recommended-main " *ngIf="!noRecord">


  <div class="product-container  new-recommended-design" *ngIf="!noRecord" infiniteScroll [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="50" (scrolled)="onScrollDown()" [scrollWindow]="false" [horizontal]="true">

    <div class="info-part w-100 justify-content-between" *ngIf="!noRecord">
      <div>
        <div class="heading">
          Recommended Products <span class="simple-font-family">({{totalProductCount}})</span>
        </div>
        <h3>
          <img *ngIf="salesRepDetail.salesrep_image" src="{{profileImagePath}}{{salesRepDetail.salesrep_image}}"
            alt="{{salesRepDetail.salesrep_image}}">
          <img *ngIf="!salesRepDetail.salesrep_image" src="../../../../assets/images/profile.svg"
            alt="{{salesRepDetail.sales_rep_name}}">
          <span>{{salesRepDetail.sales_rep_name}}</span>
        </h3>
      </div>

      <a href="javascript:void(0)" class="view-all-new" [routerLink]="['/product/recommended-products']">View All</a>
    </div>
    <div class="product-wrap-main scrollbar">

      <div class="product-wrapper" id="productslider_{{product.sku}}" *ngFor="let product of productList">
        <span>
          <div id="product_flip_{{product.sku}}" class="player" [class.voted]="product.flipped">
            <div class="front">
              <div class="product-image">
                <a [routerLink]="['/product/detail',product.sku]">
                  <img src="{{imagePath}}{{product?.images[0]}}" alt="" width="100%">
                </a>
                <img id="image_{{product.sku}}" class="wos-info" (click)="flipIt(product)"
                  src="../../.././../assets/images/wos_info.svg" alt="">
                <span class="sponsered" *ngIf="product.is_sponsored == '1'"> <img
                    src="../../.././../assets/images/Ellipse63.png"> Sponsored</span>
              </div>
              <div class="product-description">
                <a routerLink="/product/detail/{{product.sku}}" class="product-detail-name-bar">
                  <h2>{{product.short_desc}}</h2> <span class="weight">{{product.unit_size}}</span>
                </a>
                <ul class="order-quantity-details">
                  <li>
                    <span>RSP</span>
                    <p><strong class="text-dark red" *ngIf="product.rsp !== '0.00'">£{{product.rsp}}</strong>
                      <strong class="text-dark" *ngIf="product.rsp == '0.00'">N/A</strong>
                      <strong class="text-dark"
                        *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && (product.sale_unit == 'Kilo' || product.sale_unit == 'Each'))">per
                        100g</strong>
                      <strong class="text-dark"
                        *ngIf="product.rsp != '0.00' && (product.sale_unit != '' && product.sale_unit.indexOf('C') !== -1)">
                        Each</strong>
                  </li>
                  <li *ngIf="global_data != null && global_data?.margin_visibility == 1">
                    <span>Margin</span>
                    <p><span class="text-dark font-13 red">{{product.margin}}%</span></p>
                  </li>

                  <li>
                    <span>Case</span>
                    <p><strong class="text-dark">{{product.size_case}}</strong></p>
                  </li>
                  <li *ngIf="global_data != null && global_data?.price_visibility == 1">
                    <span>Cost</span>
                    <p><strong class="text-dark">£{{product.price}}</strong></p>
                  </li>

                </ul>
                <div class="btn-group flex-wrap justify-content-center">

                  <p [ngClass]="{'btn primary-btn w-100':true, 'disabled hide':product.back_in_stock == '0' ?true : false}"
                    id="btnadd_{{product.product_id}}"
                    *ngIf="product.item_id == '' && miniCartDetails != null && miniCartDetails.items_count != 0"
                    (click)="addToCart(product, product.qty, '', 'common', commonTemplate,commonTemplateFor24HrPopup,true)">
                    Add</p>
                  <p [ngClass]="{'btn primary-btn w-100':true, 'disabled hide':product.back_in_stock == '0' ?true : false}"
                    id="btnaddd_{{product.product_id}}"
                    *ngIf="product.item_id == '' && miniCartDetails.items_count == 0"
                    (click)="addToCart(product, product.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,true)">
                    Add</p>

                  <p class="out-of-stock" *ngIf="product.back_in_stock == '0'">Out of Stock
                  </p>


                  <p *ngIf="product.item_id == ''"
                    [ngClass]="{'btn not-interested-btn w-100 text-center text-dark':true}"
                    id="notinterestbtn_{{product.product_id}}" (click)="notInteretedSuggest(product)">Not
                    Interested</p>


                </div>
                <ngx-number-spinner id="spinerbtn_{{product.product_id}}" *ngIf="product.item_id != ''"
                  [ngClass]="{'spinner':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                  [value]="toInteger(product.qty)" [min]="0" (change)="send(product, $event, commonTemplate)">
                </ngx-number-spinner>
              </div>
            </div>
            <div class="back">
              <div class="back-name-revese">
                <a class="product-detail-name-bar">
                  <h2>{{product.recommendation_name}}</h2>
                </a>
                <img class="wos-info" (click)="flipIt(product)"
                  src="../../.././../assets/images/wos_card_reverse_24_24.svg" alt="">
              </div>

              <div class="description-back">
                {{product.recommendation_message}}
              </div>

              <div class="btn-group flex-wrap justify-content-center mt-4">
                <p [ngClass]="{'btn primary-btn w-100':true, 'disabled hide':product.back_in_stock == '0' ?true : false}"
                  id="btnaddtocart_{{product.product_id}}"
                  *ngIf="product.item_id == '' && miniCartDetails != null && miniCartDetails.items_count != 0"
                  (click)="addToCart(product, product.qty, '', 'common', commonTemplate,commonTemplateFor24HrPopup,true)">
                  Add</p>
                <p [ngClass]="{'btn primary-btn w-100':true, 'disabled hide':product.back_in_stock == '0' ?true : false}"
                  id="btnaddtocart_{{product.product_id}}"
                  *ngIf="product.item_id == '' && miniCartDetails.items_count == 0"
                  (click)="addToCart(product, product.qty, addToCartTemplate, 'cart', commonTemplate,commonTemplateFor24HrPopup,true)">
                  Add</p>

                <p class="out-of-stock" *ngIf="product.back_in_stock == '0'">Out of Stock
                </p>

                <p *ngIf="product.item_id == ''" [ngClass]="{'btn not-interested-btn w-100 text-center text-dark':true}"
                  id="notinterestbtntr_{{product.product_id}}" (click)="notInteretedSuggest(product)">Not
                  Interested</p>


              </div>

              <ngx-number-spinner id="spinerbtntr_{{product.product_id}}" *ngIf="product.item_id != ''"
                [ngClass]="{'spinner':true, 'disabled':product.back_in_stock == '0' ?true : false}"
                [value]="toInteger(product.qty)" [min]="0" (change)="send(product, $event, commonTemplate)">
              </ngx-number-spinner>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>

</div>